/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardTemplate } from './ScorecardTemplate.js';
import {
    ScorecardTemplateFromJSON,
    ScorecardTemplateFromJSONTyped,
    ScorecardTemplateToJSON,
} from './ScorecardTemplate.js';

/**
 * 
 * @export
 * @interface ScorecardTemplateSingleResponse
 */
export interface ScorecardTemplateSingleResponse {
    /**
     * 
     * @type {ScorecardTemplate}
     * @memberof ScorecardTemplateSingleResponse
     */
    data?: ScorecardTemplate;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSingleResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSingleResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSingleResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScorecardTemplateSingleResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScorecardTemplateSingleResponse interface.
 */
export function instanceOfScorecardTemplateSingleResponse(value: object): boolean {
    return true;
}

export function ScorecardTemplateSingleResponseFromJSON(json: any): ScorecardTemplateSingleResponse {
    return ScorecardTemplateSingleResponseFromJSONTyped(json, false);
}

export function ScorecardTemplateSingleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardTemplateSingleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ScorecardTemplateFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScorecardTemplateSingleResponseToJSON(value?: ScorecardTemplateSingleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ScorecardTemplateToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

